import Auth from './auth';
import Manager from './manager';
import Utility from '../utilites';

class Api {
  get Auth() {
    return this._auth;
  }

  get Manager() {
    return this._manager;
  }

  constructor() {
    this._networkLayer = Utility.networkLayer;
    this._auth = new Auth(this._networkLayer);
    this._manager = Manager;
  }

  set store(store) {
    this._store = store;
    this._store.subscribe(() => this._updateToken());
    this._updateToken();
  }

  get dispatch() {
    return this._store.dispatch;
  }

  _updateToken() {
    let {
      auth: {
        token
      }
    } = this._store.getState();
    this._networkLayer.authToken = token;
  }
}

export default new Api();



// WEBPACK FOOTER //
// ./src/api/index.js